"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrl = getUrl;
var _axios = require("@ori/axios");
var _types = require("../types");
var _getHeaders = require("./getHeaders");
var _isDataMockup = require("./isDataMockup");
/* eslint-disable import/no-deprecated -- utility for legacy usages */

/** @deprecated Use API instead if possible. */
async function getUrl({
  applicationName,
  basePath,
  currentLanguage,
  host,
  isAddingSpecialHeadersForbidden,
  isAuthorizationRequired,
  method: originalMethod,
  query,
  tenant,
  formattedToken,
  ...config
}) {
  let isMockup = false;
  if (process.env.NODE_ENV !== 'production') {
    isMockup = (0, _isDataMockup.isDataMockup)(applicationName);
  }
  let method = originalMethod;
  let url = `${host}${basePath}${query ?? ''}`;
  if (isMockup) {
    method = _types.HttpMethod.Get;
    url = `/mockups${basePath}.json`;
  }
  const isTokenRequired = !isMockup && isAuthorizationRequired;
  const headers = {
    ...config.headers,
    ...(isTokenRequired && {
      Authorization: formattedToken
    }),
    ...(0, _getHeaders.getHeaders)({
      currentLanguage,
      isAddingSpecialHeadersForbidden,
      tenant
    }, applicationName)
  };
  const {
    data
  } = await _axios.axios.request({
    ...config,
    headers,
    method,
    url
  });
  return data;
}
//# sourceMappingURL=getUrl.js.map